import { useState, useEffect } from "react";

export const useImageToBase64 = (url) => {
    const [imgSrc, setImgSrc] = useState(null);
    const BACKEND_URL = process.env.REACT_APP_ENTERPRISE_BACKEND_URL

    useEffect(() => {
        if (!url) { setImgSrc(null); return; }
        if (url.startsWith("data:") || url.startsWith("blob:")) { setImgSrc(url); return; }

        const load = async () => {
            try {
                const proxyUrl = `${BACKEND_URL}/api/letters/proxy-image?url=${encodeURIComponent(url)}`;
                const token = localStorage.getItem("token") || localStorage.getItem("authToken") || "";

                const response = await fetch(proxyUrl, { headers: { 'Authorization': `Bearer ${token}` } });
                if (!response.ok) throw new Error("Proxy request failed");
                const data = await response.json();

                if (data.base64) setImgSrc(data.base64);
                else setImgSrc(url);
            } catch (error) {
                console.warn("Backend Proxy failed, falling back to URL:", error);
                setImgSrc(url);
            }
        };
        load();
    }, [url, BACKEND_URL]);

    return imgSrc;
};